import withComponent from "@/hoc/withComponent";
import FlexStyled from "@/styled/FlexStyled";
import Pointer from "@/styled/Pointer";
import moment from "moment";
import React, { useCallback, useEffect, useState,useRef } from "react";
import styled from "styled-components";
import isVip2, { isDVIP, isSVIP } from "@/common/isVip";
import { useDispatch, useSelector } from "react-redux";
import { svipLastId } from "@/const/pay";
import { useNavigate } from "react-router-dom";
import { logoutUserThunk } from "@/redux/thunk/user";
import { aigetUsedPointHistory, getUserRemainingDetail } from "@/http/api";
import GetReportSuccessModal from "@/components/PayModal/GetReportSuccessModal.js";
import GetReportModal from "@/components/PayModal/GetReportModal";
const CellStyled = styled.div`
  cursor: pointer;
  height: 36px;
  padding: 0 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 14px;

  &:hover {
    background: #eceff1;
  }
`;
const icon3 = (
  <div
    style={{ height: 18 }}
    dangerouslySetInnerHTML={{
      __html: `<svg width='18px' height='18px' viewBox='0 0 18 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
    <g id='编辑页首页--工作台' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
        <g id='右上角登录优化' transform='translate(-1284.000000, -313.000000)' fill='#666666' fill-rule='nonzero' stroke='#666666'>
            <g id='编组-46备份' transform='translate(1268.000000, 69.000000)'>
                <g id='shoucang备份-15' transform='translate(16.000000, 244.000000)'>
                    <g id='tuichudenglu' transform='translate(2.500000, 2.500000)'>
                        <path d='M10.8816964,0 L2.92645089,0 C1.75848214,0 0.808147321,0.951822043 0.808147321,2.1216186 L0.808147321,3.69248826 C0.808147321,3.98166778 1.04174107,4.2156271 1.33046875,4.2156271 C1.61919643,4.2156271 1.85279018,3.98166778 1.85279018,3.69248826 L1.85279018,2.1216186 C1.85279018,1.52872792 2.33448661,1.04627767 2.92645089,1.04627767 L10.8816964,1.04627767 C11.4736607,1.04627767 11.9553571,1.52872792 11.9553571,2.1216186 L11.9553571,10.8783814 C11.9553571,11.4712721 11.4736607,11.9537223 10.8816964,11.9537223 L2.92645089,11.9537223 C2.33448661,11.9537223 1.85279018,11.4712721 1.85279018,10.8783814 L1.85279018,9.27554214 C1.85279018,8.98636262 1.61919643,8.75240331 1.33046875,8.75240331 C1.04174107,8.75240331 0.808147321,8.98636262 0.808147321,9.27554214 L0.808147321,10.8783814 C0.808147321,12.048178 1.75848214,13 2.92645089,13 L10.8816964,13 C12.0496652,13 13,12.048178 13,10.8783814 L13,2.1216186 C13,0.951822043 12.0496652,0 10.8816964,0 Z' id='路径' stroke-width='0.2'></path>
                        <path d='M7.04698661,8.93114241 C6.85111607,9.14330427 6.86417411,9.47462553 7.07600446,9.67080259 C7.17611607,9.76380505 7.30379464,9.81030628 7.43002232,9.81030628 C7.57075893,9.81030628 7.71149554,9.75363291 7.81450893,9.64173932 L10.3883929,6.85166555 C10.4827009,6.74994411 10.5276786,6.62061256 10.5262617,6.49128102 C10.5276786,6.36340264 10.48125,6.23407109 10.3883929,6.13089649 L7.81450893,3.34082271 C7.61863839,3.12866085 7.28783482,3.11558238 7.07600446,3.31175945 C6.86417411,3.50793651 6.85111607,3.83925777 7.04698661,4.05141963 L8.81127232,5.9637827 L0.522321429,5.9637827 C0.23359375,5.9637827 0,6.19774201 0,6.48692153 C0,6.77610105 0.23359375,7.01006036 0.522321429,7.01006036 L8.81852679,7.01006036 L7.04698661,8.93114241 Z' id='路径' stroke-width='0.1'></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`,
    }}
  />
);
export const vipIcon = (
  <div
    style={{ height: 29, width: 45, position: "relative" }}
    dangerouslySetInnerHTML={{
      __html: `<svg width='45px' height='29px' viewBox='0 0 45 29' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='position: absolute;top: 0;left: 0'>
    <defs>
        <filter x='-25.8%' y='-58.6%' width='145.5%' height='224.3%' filterUnits='objectBoundingBox' id='filter-1'>
            <feOffset dx='0' dy='0' in='SourceAlpha' result='shadowOffsetOuter1'></feOffset>
            <feGaussianBlur stdDeviation='1.5' in='shadowOffsetOuter1' result='shadowBlurOuter1'></feGaussianBlur>
            <feColorMatrix values='0 0 0 0 0.265483469   0 0 0 0 0.265483469   0 0 0 0 0.265483469  0 0 0 0.49532889 0' type='matrix' in='shadowBlurOuter1' result='shadowMatrixOuter1'></feColorMatrix>
            <feMerge>
                <feMergeNode in='shadowMatrixOuter1'></feMergeNode>
                <feMergeNode in='SourceGraphic'></feMergeNode>
            </feMerge>
        </filter>
        <linearGradient x1='50%' y1='0%' x2='50%' y2='100%' id='linearGradient-2'>
            <stop stop-color='#05DFD1' offset='0%'></stop>
            <stop stop-color='#02BBA4' offset='100%'></stop>
        </linearGradient>
        <filter x='-65.5%' y='-77.4%' width='231.0%' height='254.8%' filterUnits='objectBoundingBox' id='filter-3'>
            <feOffset dx='0' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'></feOffset>
            <feGaussianBlur stdDeviation='1' in='shadowOffsetOuter1' result='shadowBlurOuter1'></feGaussianBlur>
            <feColorMatrix values='0 0 0 0 0.192048092   0 0 0 0 0.608469203   0 0 0 0 0.571362371  0 0 0 1 0' type='matrix' in='shadowBlurOuter1' result='shadowMatrixOuter1'></feColorMatrix>
            <feMerge>
                <feMergeNode in='shadowMatrixOuter1'></feMergeNode>
                <feMergeNode in='SourceGraphic'></feMergeNode>
            </feMerge>
        </filter>
        <path d='M16.4392804,3.996 L18.2023988,8.51174213 L19.9925037,3.996 L21.4317841,3.996 L18.8050975,9.996 L17.5277361,9.996 L15,3.996 L16.4392804,3.996 Z M23.3388306,3.996 L23.3388306,9.996 L22.0614693,9.996 L22.0614693,3.996 L23.3388306,3.996 Z M27.5487256,3.996 C28.0944528,3.996 28.4842579,4.03498051 28.7181409,4.11294153 C29.113943,4.24487556 29.4257871,4.51773913 29.6536732,4.93153223 C29.8215892,5.24337631 29.9055472,5.5822069 29.9055472,5.94802399 C29.9055472,6.25387106 29.850075,6.54322639 29.7391304,6.81608996 C29.6281859,7.08895352 29.4737631,7.31234183 29.2758621,7.48625487 C29.095952,7.64217691 28.9055472,7.75012294 28.7046477,7.81009295 C28.5037481,7.87006297 28.2293853,7.90004798 27.8815592,7.90004798 L25.8305847,7.90004798 L25.8305847,9.996 L24.5532234,9.996 L24.5532234,3.996 L27.5487256,3.996 Z M27.5937031,5.06646477 L25.8305847,5.06646477 L25.8305847,6.82958321 L27.5667166,6.82958321 C27.8785607,6.82958321 28.0974513,6.7816072 28.2233883,6.68565517 C28.4092954,6.53573013 28.5022489,6.27486057 28.5022489,5.90304648 C28.5022489,5.50124738 28.3613193,5.24337631 28.0794603,5.12943328 C27.9775112,5.08745427 27.8155922,5.06646477 27.5937031,5.06646477 Z' id='path-4'></path>
        <filter x='-23.5%' y='-41.7%' width='147.0%' height='216.7%' filterUnits='objectBoundingBox' id='filter-5'>
            <feOffset dx='0' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'></feOffset>
            <feGaussianBlur stdDeviation='1' in='shadowOffsetOuter1' result='shadowBlurOuter1'></feGaussianBlur>
            <feColorMatrix values='0 0 0 0 0.192048092   0 0 0 0 0.608469203   0 0 0 0 0.571362371  0 0 0 1 0' type='matrix' in='shadowBlurOuter1'></feColorMatrix>
        </filter>
    </defs>
    <g id='个人中心' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
        <g id='右上角优化2.0' transform='translate(-1345.000000, -97.000000)'>
            <g id='编组-19备份' transform='translate(1314.000000, 59.000000)'>
                <g id='编组-18' filter='url(#filter-1)' transform='translate(38.000000, 45.000000)'>
                    <g id='编组-17备份'>
                        <rect id='矩形' fill='url(#linearGradient-2)' x='0' y='0' width='33' height='14' rx='7'></rect>
                        <g id='VIP会员备份' filter='url(#filter-3)' transform='translate(3.000000, 3.300000)' fill='#FFFFFF' fill-rule='nonzero'>
                            <g id='f-vip'>
                                <path d='M9.88038489,3.15944388 L8.33925151,0.225240536 C8.2666074,0.0869478694 8.12100527,0 7.96205681,0 L1.98287144,0 C1.82468585,0 1.67964974,0.0861228758 1.60666238,0.22340193 L0.0478560616,3.15502674 C-0.0359110026,3.31256319 -0.00787616508,3.50478269 0.117585106,3.63312055 L4.65234546,8.2718805 C4.73227941,8.35364268 4.84288429,8.4 4.95853894,8.4 L4.95882547,8.4 C5.07438511,8.4 5.18493917,8.35386636 5.26491581,8.27227289 L9.80929198,3.63608025 C9.93453859,3.50831841 9.96309199,3.31688456 9.88038489,3.15944388 L9.88038489,3.15944388 Z M7.46875017,3.62640515 L5.26739139,5.87224086 C5.18741475,5.95383433 5.07686069,5.99996797 4.96130106,5.99996797 L4.96101453,5.99996797 C4.84535736,5.99989166 4.73475072,5.95360685 4.65482105,5.87183726 L2.45813837,3.62476834 C2.29627393,3.45919283 2.30227952,3.19661961 2.47154781,3.03828642 C2.64081609,2.87994202 2.90924541,2.88582781 3.07110986,3.05140331 L4.96172512,4.98538217 L6.85658096,3.05224414 C7.01866317,2.88688164 7.28711541,2.88136582 7.45615448,3.03991202 C7.62519354,3.19845822 7.63084384,3.46104265 7.46875017,3.62640515 L7.46875017,3.62640515 Z' id='形状'></path>
                            </g>
                        </g>
                    </g>
                    <g id='形状结合' fill-rule='nonzero'>
                        <use fill='black' fill-opacity='1' filter='url(#filter-5)' xlink:href='#path-4'></use>
                        <use fill='#FFFFFF' xlink:href='#path-4'></use>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`,
    }}
  />
);
export const svipIcon = (
  <div
    style={{ height: 29, width: 51, position: "relative" }}
    dangerouslySetInnerHTML={{
      __html: `<svg width='51px' height='29px' viewBox='0 0 51 29' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='position: absolute;top: 0;left: 0'>
    <defs>
        <filter x='-21.8%' y='-58.6%' width='138.5%' height='224.3%' filterUnits='objectBoundingBox' id='filter-1'>
            <feOffset dx='0' dy='0' in='SourceAlpha' result='shadowOffsetOuter1'></feOffset>
            <feGaussianBlur stdDeviation='1.5' in='shadowOffsetOuter1' result='shadowBlurOuter1'></feGaussianBlur>
            <feColorMatrix values='0 0 0 0 0.265483469   0 0 0 0 0.265483469   0 0 0 0 0.265483469  0 0 0 0.49532889 0' type='matrix' in='shadowBlurOuter1' result='shadowMatrixOuter1'></feColorMatrix>
            <feMerge>
                <feMergeNode in='shadowMatrixOuter1'></feMergeNode>
                <feMergeNode in='SourceGraphic'></feMergeNode>
            </feMerge>
        </filter>
        <linearGradient x1='50%' y1='0%' x2='50%' y2='100%' id='linearGradient-2'>
            <stop stop-color='#FADFA3' offset='0%'></stop>
            <stop stop-color='#F4BC6A' offset='100%'></stop>
        </linearGradient>
        <filter x='-65.5%' y='-77.4%' width='231.0%' height='254.8%' filterUnits='objectBoundingBox' id='filter-3'>
            <feOffset dx='0' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'></feOffset>
            <feGaussianBlur stdDeviation='1' in='shadowOffsetOuter1' result='shadowBlurOuter1'></feGaussianBlur>
            <feColorMatrix values='0 0 0 0 0.899598053   0 0 0 0 0.703994305   0 0 0 0 0.306477012  0 0 0 1 0' type='matrix' in='shadowBlurOuter1' result='shadowMatrixOuter1'></feColorMatrix>
            <feMerge>
                <feMergeNode in='shadowMatrixOuter1'></feMergeNode>
                <feMergeNode in='SourceGraphic'></feMergeNode>
            </feMerge>
        </filter>
        <path d='M20.2983508,3.996 L20.2983508,5.06646477 L17.6086957,5.06646477 C17.2068966,5.07246177 16.94003,5.09045277 16.808096,5.12043778 C16.5382309,5.1864048 16.4032984,5.39030285 16.4032984,5.73213193 C16.4032984,6.01998801 16.5172414,6.21189205 16.7451274,6.30784408 C16.8950525,6.3798081 17.1469265,6.4157901 17.5007496,6.4157901 L18.4632684,6.4157901 C18.9550225,6.4157901 19.3208396,6.45776912 19.5607196,6.54172714 C19.9865067,6.68565517 20.2803598,6.93752924 20.4422789,7.29734933 C20.5682159,7.5852054 20.6311844,7.89405097 20.6311844,8.22388606 C20.6311844,8.58970315 20.5472264,8.91653973 20.3793103,9.2043958 C20.1454273,9.6121919 19.7946027,9.85806897 19.3268366,9.94202699 C19.0989505,9.978009 18.7541229,9.996 18.2923538,9.996 L15.2788606,9.996 L15.2788606,8.92553523 L18.0224888,8.92553523 C18.4602699,8.92553523 18.7511244,8.88355622 18.8950525,8.7995982 C19.1049475,8.67366117 19.2098951,8.48475562 19.2098951,8.23288156 C19.2098951,7.93902849 19.0869565,7.72613493 18.8410795,7.5942009 C18.7031484,7.51623988 18.4812594,7.47725937 18.1754123,7.47725937 L17.05997,7.47725937 C16.3823088,7.47725937 15.8935532,7.35432084 15.5937031,7.10844378 C15.4077961,6.95252174 15.2623688,6.75761919 15.1574213,6.52373613 C15.0524738,6.28985307 15,6.03797901 15,5.76811394 C15,5.34832384 15.1229385,4.96451574 15.3688156,4.61668966 C15.6086957,4.28085757 15.9925037,4.08295652 16.5202399,4.02298651 C16.7001499,4.0049955 16.9670165,3.996 17.3208396,3.996 L20.2983508,3.996 Z M22.3943028,3.996 L24.1574213,8.51174213 L25.9475262,3.996 L27.3868066,3.996 L24.7601199,9.996 L23.4827586,9.996 L20.9550225,3.996 L22.3943028,3.996 Z M29.2938531,3.996 L29.2938531,9.996 L28.0164918,9.996 L28.0164918,3.996 L29.2938531,3.996 Z M33.5037481,3.996 C34.0494753,3.996 34.4392804,4.03498051 34.6731634,4.11294153 C35.0689655,4.24487556 35.3808096,4.51773913 35.6086957,4.93153223 C35.7766117,5.24337631 35.8605697,5.5822069 35.8605697,5.94802399 C35.8605697,6.25387106 35.8050975,6.54322639 35.6941529,6.81608996 C35.5832084,7.08895352 35.4287856,7.31234183 35.2308846,7.48625487 C35.0509745,7.64217691 34.8605697,7.75012294 34.6596702,7.81009295 C34.4587706,7.87006297 34.1844078,7.90004798 33.8365817,7.90004798 L31.7856072,7.90004798 L31.7856072,9.996 L30.5082459,9.996 L30.5082459,3.996 L33.5037481,3.996 Z M33.5487256,5.06646477 L31.7856072,5.06646477 L31.7856072,6.82958321 L33.5217391,6.82958321 C33.8335832,6.82958321 34.0524738,6.7816072 34.1784108,6.68565517 C34.3643178,6.53573013 34.4572714,6.27486057 34.4572714,5.90304648 C34.4572714,5.50124738 34.3163418,5.24337631 34.0344828,5.12943328 C33.9325337,5.08745427 33.7706147,5.06646477 33.5487256,5.06646477 Z' id='path-4'></path>
        <filter x='-16.8%' y='-41.7%' width='133.6%' height='216.7%' filterUnits='objectBoundingBox' id='filter-5'>
            <feOffset dx='0' dy='1' in='SourceAlpha' result='shadowOffsetOuter1'></feOffset>
            <feGaussianBlur stdDeviation='1' in='shadowOffsetOuter1' result='shadowBlurOuter1'></feGaussianBlur>
            <feColorMatrix values='0 0 0 0 0.899598053   0 0 0 0 0.703994305   0 0 0 0 0.306477012  0 0 0 1 0' type='matrix' in='shadowBlurOuter1'></feColorMatrix>
        </filter>
    </defs>
    <g id='个人中心' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
        <g id='右上角优化2.0' transform='translate(-1629.000000, -97.000000)'>
            <g id='编组-19' transform='translate(1598.000000, 59.000000)'>
                <g id='编组-18' filter='url(#filter-1)' transform='translate(38.000000, 45.000000)'>
                    <g id='编组-17备份'>
                        <rect id='矩形' fill='url(#linearGradient-2)' x='0' y='0' width='39' height='14' rx='7'></rect>
                        <g id='VIP会员备份' filter='url(#filter-3)' transform='translate(3.000000, 3.300000)' fill='#FFFFFF' fill-rule='nonzero'>
                            <g id='f-vip'>
                                <path d='M9.88038489,3.15944388 L8.33925151,0.225240536 C8.2666074,0.0869478694 8.12100527,0 7.96205681,0 L1.98287144,0 C1.82468585,0 1.67964974,0.0861228758 1.60666238,0.22340193 L0.0478560616,3.15502674 C-0.0359110026,3.31256319 -0.00787616508,3.50478269 0.117585106,3.63312055 L4.65234546,8.2718805 C4.73227941,8.35364268 4.84288429,8.4 4.95853894,8.4 L4.95882547,8.4 C5.07438511,8.4 5.18493917,8.35386636 5.26491581,8.27227289 L9.80929198,3.63608025 C9.93453859,3.50831841 9.96309199,3.31688456 9.88038489,3.15944388 L9.88038489,3.15944388 Z M7.46875017,3.62640515 L5.26739139,5.87224086 C5.18741475,5.95383433 5.07686069,5.99996797 4.96130106,5.99996797 L4.96101453,5.99996797 C4.84535736,5.99989166 4.73475072,5.95360685 4.65482105,5.87183726 L2.45813837,3.62476834 C2.29627393,3.45919283 2.30227952,3.19661961 2.47154781,3.03828642 C2.64081609,2.87994202 2.90924541,2.88582781 3.07110986,3.05140331 L4.96172512,4.98538217 L6.85658096,3.05224414 C7.01866317,2.88688164 7.28711541,2.88136582 7.45615448,3.03991202 C7.62519354,3.19845822 7.63084384,3.46104265 7.46875017,3.62640515 L7.46875017,3.62640515 Z' id='形状'></path>
                            </g>
                        </g>
                    </g>
                    <g id='形状结合' fill-rule='nonzero'>
                        <use fill='black' fill-opacity='1' filter='url(#filter-5)' xlink:href='#path-4'></use>
                        <use fill='#FFFFFF' xlink:href='#path-4'></use>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`,
    }}
  />
);
const ThemeButton = styled.div`
  cursor: pointer;
  background: #11bba6;

  :hover {
    background: #0d9584;
    color: white;
  }

  :active {
    background: #0fa795;
    color: white;
  }
`;
const Text1Styled = styled.div`
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 14px;
  white-space: nowrap;
`;
const Text5Styled = styled.div`
  width: 64px;
  height: 24px;
  background: rgba(251, 107, 90, 0.12);
  border-radius: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #fb5e55;
  line-height: 24px;
  text-align: center;
`;

const Cell = (props) => {
  const { onClick, children, icon } = props;
  return (
    <CellStyled onClick={onClick}>
      <FlexStyled
        $alignItems="center"
        style={{ width: "100%", height: "100%" }}
      >
        {<span style={{ marginRight: 10 }}>{icon}</span>}
        <div style={{ height: "fit-content" }}>{children}</div>
      </FlexStyled>
    </CellStyled>
  );
};
const Cell2 = (props) => {
  const { onClick, title, right } = props;
  return (
    <CellStyled onClick={onClick}>
      <FlexStyled
        $alignItems="center"
        $justifyContent="space-between"
        style={{ width: "100%", height: "100%" }}
      >
        <Text1Styled>{title}</Text1Styled>
        <div>{right}</div>
      </FlexStyled>
    </CellStyled>
  );
};

const BoxPositionStyled = styled.div`
  position: absolute;
  left: -230px;
  padding-top: 10px;
`;
const BoxStyled = styled.div`
  overflow: hidden;
  padding-bottom: 10px;
  width: 272px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;
const AStyled = styled.div`
  width: 44px;
  height: 44px;
  color: black;
  line-height: normal;
  border-radius: 50%;
  overflow: hidden;
  background-size: 100% 100%;
  ${(props) => (props.bg ? `background-image:url(${props.bg});` : "")}
`;
const ButtonStyled = styled.div`
  line-height: 24px;
  cursor: pointer;
  text-align: center;
  width: 68px;
  height: 24px;
  background: #feecbb;
  border-radius: 12px;

  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9f823f;
`;
const Text3Styled = styled.div`
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #c7c7c7;
`;
const Text4Styled = styled(ThemeButton)`
  width: 64px;
  height: 24px;
  border-radius: 12px;

  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  text-align: center;
`;
const defaultIcon = (
  <div
    style={{ height: 44, width: 44 }}
    dangerouslySetInnerHTML={{
      __html: ` <svg width="44" height="44" viewBox='0 0 24 24'version='1.1'>
    <g
        id='页面-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
    >
        <g id='User' transform='translate(-240.000000, -48.000000)'>
            <g
                id='user_4_fill'
                transform='translate(240.000000, 48.000000)'
            >
                <rect
                    id='矩形'
                    fillRule='nonzero'
                    x='0'
                    y='0'
                    width='24'
                    height='24'
                ></rect>
                <path
                    d='M12,2 C6.47715,2 2,6.47715 2,12 C2,17.5228 6.47715,22 12,22 C17.5228,22 22,17.5228 22,12 C22,6.47715 17.5228,2 12,2 Z M8.5,8.5 C8.5,6.567 10.067,5 12,5 C13.933,5 15.5,6.567 15.5,8.5 C15.5,10.433 13.933,12 12,12 C10.067,12 8.5,10.433 8.5,8.5 Z M5.2782,16.3396 C6.92693,14.9918 9.33472,14 12,14 C14.6653,14 17.0731,14.9918 18.7218,16.3396 C17.2969,18.5423 14.8187,20 12,20 C9.18136,20 6.70318,18.5423 5.2782,16.3396 Z'
                    id='形状'
                    fill='#cccccc'
                ></path>
            </g>
        </g>
    </g>
</svg>`,
    }}
  />
);
const Text2Styled = styled.div`
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 17px;
  opacity: 0.56;
`;

export default withComponent((props) => {
  const {
    onMouseEnter,
    onMouseLeave,
    setCShow,
    setLoginVisible,
    onClickPay,
    menuVisible,
    onClickReport
  } = props;
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const {enterpriseMbtiMobile,enterpriseMbtiMobileState} = user
  
  const [userRemainingDetail, setuserRemainingDetail] = useState({});
  const onClickGoWorkspace = useCallback(() => {
    navigate("/workspace");
  }, []);
  const onClickT = useCallback(() => {
    navigate("/personalCenter?type=telephone");
  }, []);
  const onLogOut = async () => {
    await dispatch(logoutUserThunk());
    window.location.reload();
  };
  const onClickAi = () => {
    window.open("/personalCenter?type=ai");
  };
  const onClickRecord = () => {
    window.open("/personalCenter");
  };





  useEffect(() => {
    if (menuVisible) {
      getUserRemainingDetail().then((res) => {
        setuserRemainingDetail(res);
      });
    }
  }, [menuVisible]);

  const vipTime = user?.editableVipTime;
  const dispatch = useDispatch();
  const isVip = isVip2();
  const userName = user?.userName;
  const icon = user?.icon;
  const isDV = isDVIP();
  const isSV = isSVIP();
  const telephoneBlindVisible = !user?.isPhoneLogin;
  const clickTestRight = <Text5Styled>待领取</Text5Styled>;
  const chatGPTRight = userRemainingDetail ? (
    <Text2Styled>{`本月剩余：${userRemainingDetail.remainingPagePoint}次`}</Text2Styled>
  ) : undefined;
  const downRight = userRemainingDetail ? (
    <Text2Styled>{`本月剩余：${userRemainingDetail.remainingDownNum}次`}</Text2Styled>
  ) : undefined;
  return (
    <BoxPositionStyled onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <BoxStyled>
        <FlexStyled
          $alignItems="center"
          $justifyContent="space-between"
          style={{ height: 74 }}
        >
          <FlexStyled $alignItems="center">
            <FlexStyled
              $alignItems="center"
              style={{
                position: "relative",
                borderRadius: "50%",
                marginLeft: 16,
                marginRight: 22,
                height: "100%",
              }}
            >
              <div style={{ position: "relative" }}>
                <AStyled
                  bg={user.icon}
                  style={{
                    border: isDV
                      ? "1px solid #42CDBB"
                      : isSV
                      ? "1px solid #F4BC6A"
                      : undefined,
                  }}
                >
                  {!icon && defaultIcon}
                </AStyled>
                <div style={{ position: "absolute", top: 24, left: 15 }}>
                  {isDVIP() && vipIcon}
                  {isSVIP() && svipIcon}
                </div>
              </div>
            </FlexStyled>
            <div>
              <div style={{ fontSize: 12, fontWeight: 400, color: "#8694AB" }}>
                {userName}
              </div>
              {isVip && (
                <Text3Styled>
                  {moment(vipTime).format("YYYY.MM.DD到期")}
                </Text3Styled>
              )}
            </div>
          </FlexStyled>
          {isVip && user.vipType !== 22 && (
            <ButtonStyled onClick={onClickPay} style={{ marginRight: 12 }}>
              升级会员
            </ButtonStyled>
          )}
        </FlexStyled>
        {!isVip && (
          <Pointer
            onClick={onClickPay}
            style={{
              width: "100%",
              height: 68,
              overflow: "hidden",
              marginBottom: 10,
            }}
          >
            <img
              src="https://oss.jianzeppt.com/user/12426/10fc2d1c-5bbb-4eeb-aae8-5d20c2c4a98c.png"
              width="100%"
            />
          </Pointer>
        )}
        <Cell2 title="我的简历" onClick={onClickGoWorkspace} />
        {/*<Cell2 title="我的收藏"/>*/}
        <Cell2 title="下载记录" onClick={onClickRecord} right={downRight} />
        <Cell2
          title="AI ChatGPT记录"
          right={chatGPTRight}
          onClick={onClickAi}
        />
        { enterpriseMbtiMobileState &&<Cell2
          title="职业性格测评机会"
          right={enterpriseMbtiMobileState===1?clickTestRight:null}
          onClick={onClickReport}
        />}
        {telephoneBlindVisible && (
          <Cell2
            onClick={onClickT}
            title="手机号绑定"
            right={<Text4Styled>立即绑定</Text4Styled>}
          />
        )}
        <div
          style={{ height: 1, background: "#F3F3F3", margin: "10px 17px" }}
        />
        <Cell onClick={onLogOut} icon={icon3}>
          退出登录
        </Cell>
      </BoxStyled>

    </BoxPositionStyled>
  );
});
